/*
Luke Harby
slackwise LTD
https://slackwise.org.uk
2012 - present
*/

/* search function */
import { DOM } from '../utils/global';
let searchInput = DOM.querySelector('.search__input');
let searchTrigger = DOM.querySelector('.search__link');

const search = () => {
    searchInput = DOM.querySelector('.search__input');
    searchTrigger = DOM.querySelector('.search__link');
    searchTrigger?.addEventListener('click', () => {
        searchTrigger.setAttribute('href', `/search?q=${encodeURIComponent(searchInput.value)}`);
    });
}

export {
    search,
    searchInput,
    searchTrigger
};